(function(){
    window.initMobSlidersBlockFunc = function (block, mediaSize, itemsSelector, slideSelector) {
        const holder = block.querySelector(itemsSelector);
        const slides = block.querySelectorAll(slideSelector);
        if ((! holder) || (slides.length == 0)) {
          return;
        } 
        let isSlider = false;
        let flickity = null;
        const media = matchMedia('screen and (max-width: ' + mediaSize +'px)');   
        const initFlickity = function(){
          flickity = new Flickity( holder, {
            prevNextButtons: false,
            cellAlign: 'left',
            groupCells: false,
            imagesLoaded: true,
            pageDots: false,
            percentPosition: false,
            autoPlay: false,
            pauseAutoPlayOnHover: false,
            //adaptiveHeight: false,
            cellSelector: slideSelector,
            selectedAttraction: 0.05,
            wrapAround: false,
            friction: 0.5,
            adaptiveHeight: true,  
            contain: true      
          } );
          isSlider = true;
        }
    
        if (media.matches) {
          initFlickity();
        }
        
        window.addEventListener("resize", function() {
          if (media.matches) {
            if (! isSlider) {
              initFlickity();
            }
          } else {
            if (isSlider) {
              isSlider = false;
              if (flickity) {
                flickity.destroy()
              }
            }
          }
        });
        
      }
    function statsAnimation() {
        if ( typeof gsap !== 'undefined' ) {
            gsap.registerPlugin( ScrollTrigger);
        } else {
            return;
        }
        if ( !document.querySelector( '.stats-list__items' ) ) {
            return;
        } 
        ScrollTrigger.batch( ".stats-list__item--anim", {
            onEnter: batch => {
                batch.forEach( ( section ) => {
                    const count = section.querySelector( '.stats-list__item-number' ),
                        zero = { val: 0 },
                        num = count.dataset.number,
                        split = ( num + "" ).split( "." ),
                        decimals = split.length > 1 ? split[ 1 ].length : 0

                    gsap.to( zero, {
                        val: num,
                        onUpdate () {
                            count.innerText = zero.val.toFixed( decimals )
                        },
                        onComplete () {
                            count.innerText = parseInt( zero.val, 10 ).toLocaleString( 'en-US' )
                        },
                        duration: 1.2,
                        ease: 'sine.inOut'
                    } )
                } )
            },
            once: true,
            start: "+=80% bottom"
        } )
    }

    function sideBlockAnimation() {
      if ( !document.querySelector( '.article-template__aside-inner' ) ) {
          return;
      } 
      if ( typeof gsap !== 'undefined' ) {
          gsap.registerPlugin( ScrollTrigger);
      } else {
          return;
      } 
      const container = document.querySelector( '.article-template__grid' );
      const body = container.querySelector( '.article-template__content' );
      const aside = container.querySelector( '.article-template__aside-inner' );           
      const mm = gsap.matchMedia(); 
      mm.add( "(min-width: 768px)", () => {        
          ScrollTrigger.create( {
                trigger: container,  
                start: 'top top',
                end: function() {
                  const contentH = body.offsetHeight,
                  asideH = aside.offsetHeight
                  const pinH = contentH - asideH;                 
                  return (pinH > 0) ? `+=${ pinH }` : '+=0';                  
                },                
                scrub: true,
                pin: aside,
                // markers: true,
                pinSpacing: false,
            } );
                    
      } );     
    }

    function imagesWidthHandler(imgSelecor, wrapSelector) {
        const wraps = document.querySelectorAll(wrapSelector);
        if (wraps.length == 0) {
            return;
        }
        let i, wrap, img, w;
        for(i = 0; i < wraps.length; i++) {
            wrap = wraps[i];
            img = wrap.querySelector(imgSelecor);
            if (! img) {
                continue;
            }
            w = img.getAttribute('width');
            wrap.style.width = w + 'px';
        }
    }

    function footerFixHandler() {
      const footer = document.querySelector('.footer');
      const productSticky = document.querySelector('.pr-stcb');
      const mainProduct = document.querySelector('.product.product--large');
      let featuredProduct = document.querySelector('.featured-product-section');
            
      if( !featuredProduct ) {        
        let featuredProduct = '';
      }
      
      if ((! footer) || (! productSticky) || (mainProduct == null) || (featuredProduct== null)) {
          return;
      } // redo
      let isActive = false;
      let previousY = 0;
      let previousRatio = 0;

      const observer = new IntersectionObserver(function (entries) {
        entries.forEach((entry) => {        
          if (entry.target === footer) {
            if ((entry.intersectionRatio > 0) && isActive){
              isActive = false;
              productSticky.classList.add('pr-stcb--hidden');
            } else if (entry.intersectionRatio == 0 && (! isActive) ) {
              productSticky.classList.remove('pr-stcb--hidden');
              isActive = true;
            }
          }
          else if (entry.target === featuredProduct) {
            const currentY = entry.boundingClientRect.y;
            const currentRatio = entry.intersectionRatio;
            const isIntersecting = entry.isIntersecting;
        
            // Scrolling down/up
            if (currentY < previousY) {
              if ( entry.intersectionRatio > 0 ) {
                productSticky.classList.remove('pr-stcb--hidden');
              }
            } else if (currentY > previousY && isIntersecting) {
              if ( entry.intersectionRatio > 0 ) {
                productSticky.classList.add('pr-stcb--hidden');
              }
            }
        
            previousY = currentY;
            previousRatio = currentRatio;
          }
          else if (entry.target === mainProduct) { //console.log('mainProduct', entry, previousY);
            if ((entry.intersectionRatio > 0) && isActive){
              isActive = false;
              productSticky.classList.add('pr-stcb--hidden'); //console.log('if');
            } else if (entry.intersectionRatio == 0 && (! isActive) ) {
              productSticky.classList.remove('pr-stcb--hidden');
              isActive = true; //console.log('else if 4')
            }

            
            // const currentY = entry.boundingClientRect.y; 
            // const isDown = (currentY < previousY);
            // if (entry.isIntersecting && (isDown && (! isActive)) && 
            //   (entry.boundingClientRect.bottom / 2 < entry.rootBounds.height)) {
            //     productSticky.classList.remove('pr-stcb--hidden');
            //     isActive = true; //console.log('else if 2')
            // } else if (entry.isIntersecting && ((! isDown) && isActive) && 
            //   (entry.boundingClientRect.bottom / 2 >= entry.rootBounds.height)) {
            //     isActive = false;
            //     productSticky.classList.add('pr-stcb--hidden'); //console.log('else if 3')
            // } else if ((entry.intersectionRatio > 0) && isActive){
            //   isActive = false;
            //   productSticky.classList.add('pr-stcb--hidden'); //console.log('if');            
            // } else if (entry.intersectionRatio == 0 && (! isActive) ) {
            //   productSticky.classList.remove('pr-stcb--hidden');
            //   isActive = true; //console.log('else if 4')              
            // }
            // previousY = currentY;
          } 

        });

      }, {
        threshold: [0, 0.25, 0.5, 0.75, 1]
      });
        observer.observe(footer); 

      if( !featuredProduct ) {
        observer.observe(mainProduct);
      } else {
        observer.observe(featuredProduct);
      }
      
      /*
      const fixMargin = function() {
        let height = productSticky.offsetHeight;
        if (! height) {
          height = 0;
        }
        footer.style.marginBottom = height + 'px';
      }
      fixMargin();
      window.addEventListener("resize", function() {
        setTimeout(fixMargin, 300);
      }); */
    }

    document.addEventListener("DOMContentLoaded", (event) => {
        statsAnimation();
        sideBlockAnimation();
        imagesWidthHandler('.n-quote__logo', '.n-quote__logo-wrap');
        imagesWidthHandler('.certs-sec__img', '.certs-sec__item-img-wrap');
        imagesWidthHandler('.wd-roice__item-img', '.wd-roice__item-img-wrap');
        footerFixHandler();
        //imagesWidthHandler('.img-hero__cert-img', '.img-hero__cert-img-wrap');
         
        
    });

})();